import type { NEmployees } from '@app/types/Employees';

import { WS_CONDITION_HOVER } from '@pages/WorkSchedule/constants/cellConditions';

export const clearAllSelections = (
  employees: NEmployees.ModelEmployee[],
  daysRange: string[]
): void => {
  return (employees || []).forEach((_, rowIndex: number) => {
    return (daysRange || []).forEach((_, columnIndex: number) => {
      const cell = document.querySelector(`.cell-${rowIndex}-${columnIndex}`);
      const hasSelection = cell?.classList.contains(WS_CONDITION_HOVER);

      if (hasSelection) {
        return cell?.classList.remove(WS_CONDITION_HOVER);
      }
    });
  });
};
